import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center px-5">
      <div data-testid="payment-cancel" className="max-w-md w-full text-center border border-[#222] bg-[#111] p-8">
        <XCircle size={40} className="text-neutral-500 mx-auto" />
        <h1 className="font-serif text-2xl mt-5">Payment cancelled</h1>
        <p className="text-neutral-400 mt-3 text-sm">
          No worries — your appointment wasn't booked. You can start again whenever you're ready.
        </p>
        <Link
          to="/"
          className="inline-block mt-6 bg-[#C5B382] hover:bg-[#B8A572] text-[#0A0A0A] text-[12px] font-semibold tracking-[0.18em] uppercase px-8 py-3.5 transition-colors"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
}
